export default __webpack_public_path__ + "9f6561ff92775191cfd2990ca880544d.svg";